import { hero, contact } from '../../../content/agencyCopy';
import SignalCta from '../SignalCta';

/*
 * Hero — type, CTAs, and the engagement spans. No figure.
 *
 * There used to be a diagram here. It went because every module below now
 * shows a live demo at full screen height, which made the drawing a weaker
 * preview of something the reader was about to see anyway. The dimension bar
 * stays: 0-2 days to a plan and 6-9 days to a built system is the sharpest
 * claim on the page, and it costs three lines of markup to make it.
 */
export default function Hero() {
  return (
    <section
      className="fa-grid pt-36 md:pt-44 pb-16 md:pb-20 px-6"
      style={{ background: 'var(--fa-paper)' }}
    >
      <div className="max-w-[1120px] mx-auto">
        <div className="fa-label fa-hero-item flex items-center gap-3" data-i="0">
          <span className="fa-status-dot fa-status-dot--live" aria-hidden="true" />
          {hero.eyebrow}
        </div>
        <h1
          className="fa-hero-item mt-6 font-display text-[36px] sm:text-[48px] md:text-[60px]"
          data-i="1"
          style={{ maxWidth: '17ch', textWrap: 'balance' }}
        >
          {hero.headline}
        </h1>
        <p
          className="fa-hero-item mt-8 text-[17px] md:text-[19px] max-w-[60ch] fa-glow-text"
          data-i="2"
        >
          {hero.subline}
        </p>
        <div className="fa-hero-item mt-10 flex flex-wrap items-center gap-4" data-i="3">
          <SignalCta
            data-cal-link={contact.calLink}
            data-cal-namespace={contact.calNamespace}
          >
            {hero.primary}
          </SignalCta>
          <SignalCta to={hero.assessHref} variant="ghost">
            {hero.assessCtaLabel}
          </SignalCta>
        </div>
        <div className="fa-hero-item mt-6 flex flex-wrap items-center gap-x-6 gap-y-2" data-i="4">
          <a
            href={hero.secondaryHref}
            className="inline-flex items-center gap-1.5 text-[14px] transition-colors hover:opacity-80"
            style={{ color: 'var(--fa-muted)' }}
          >
            {hero.secondary}
            <span aria-hidden="true" style={{ color: 'var(--fa-signal)' }}>→</span>
          </a>
          <a
            href={contact.whatsappHref}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-[14px] transition-colors hover:opacity-80"
            style={{ color: 'var(--fa-muted)' }}
          >
            {contact.whatsappSecondaryLabel}
            <span aria-hidden="true" style={{ color: 'var(--fa-signal)' }}>→</span>
          </a>
        </div>

        {/* Engagement spans, drawn as measurements rather than a price list */}
        <div
          className="fa-hero-item mt-14 grid gap-2 sm:grid-cols-3 max-w-[720px]"
          data-i="5"
        >
          {hero.spans.map((d) => (
            <div key={d.label} className="flex items-center gap-2">
              <span className="fa-dim__cap" aria-hidden="true" />
              <span className="fa-dim flex-1">
                <span style={{ color: 'var(--fa-ink)' }}>{d.label}</span>
                <span>{d.span}</span>
              </span>
              <span className="fa-dim__cap" aria-hidden="true" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
